import type { IRequestOptions, IValidatedResponse } from '../../httpClient';
import { putRequest } from '../../httpClient';
import type { IUpdateNotificationPreferencesV1Body } from './update-notification-preferences-v1-request';
import type { IUpdateNotificationPreferencesV1Response } from './update-notification-preferences-v1-response';
import { updateNotificationPreferencesV1ResponseSchema } from './update-notification-preferences-v1-response';

export async function updateNotificationPreferencesV1Api(
  body: IUpdateNotificationPreferencesV1Body,
  options?: IRequestOptions,
): Promise<IValidatedResponse<IUpdateNotificationPreferencesV1Response>> {
  return putRequest<IUpdateNotificationPreferencesV1Response>({
    path: '/account/notification-preferences/v1',
    body,
    schema: updateNotificationPreferencesV1ResponseSchema,
    options,
  });
}
